import { render, staticRenderFns } from "./EditOrderVehiclePrice.vue?vue&type=template&id=1f349a08&scoped=true&"
import script from "./EditOrderVehiclePrice.vue?vue&type=script&lang=js&"
export * from "./EditOrderVehiclePrice.vue?vue&type=script&lang=js&"
import style0 from "./EditOrderVehiclePrice.vue?vue&type=style&index=0&id=1f349a08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f349a08",
  null
  
)

export default component.exports